/* global G */
import { curry } from 'lib/util'
import getLogPayload from 'app/_shared/events/log/getPayload'
import submit from 'app/_shared/events/log/submit'

/**
 * Log Access Event Handler
 *
 * Sends a log request to the server for the current resource.
 *
 * NOTE: Although this handler calls async functions to make the request, it
 * itself is not async, we don't want to wait for the request to be finished.
 *
 * @param {Gaia.AppModule.Spec} module    current module
 * @param {Gaia.Component.Spec} component component that triggered the event
 * @param {Gaia.PlatformEvent} event      the event object
 * @returns {void}
 */
const logAccess = (module, component, event) => {
  const settingsAdapter = module[G.ADAPTER][G.SETTINGS]

  // TODO: Checking for user setting, which doesn't exist yet, remove defaulting to
  //       `true` once it does
  const enableStatistics = settingsAdapter[G.API].get({ key: 'enableStatistics' }) || true

  if (enableStatistics) {
    const payload = /** @type {LogPayload} */ getLogPayload(module, component, event)
    submit(module, component, { detail: { payload } })
  }
}

export default curry(logAccess)
